import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CourseNav from '../../../components/CourseNav';
import HowItWorks from './HowItWorks';
import Picker from './Picker';

class Courses extends Component {
  render () {
    return (
      <div className='l-container'>
        <Helmet>
          <title>Learn British Sign Language Online with BSL Courses</title>
        </Helmet>
        <CourseNav />
        <switch>
          <Route exact path='/course-info/how-it-works' component={HowItWorks} />
          <Route exact path='/course-info/picker' component={Picker} />
          <Route render={(match) => {
            // for some weird reason this route gets matched when the above 2
            // 'exact' routes match, so added an extra if check
            if (match.location.pathname !== '/course-info/how-it-works' &&
              match.location.pathname !== '/course-info/picker') {
              return <Redirect to='/error404' />;
            }
            return null;
          }} />
        </switch>
      </div>
    );
  }
}

Courses.propTypes = {
  courses: PropTypes.array
};

export default Courses;



// WEBPACK FOOTER //
// ./src/views/Main/CourseInfo/index.js